import useSWR from "swr";
import { type QuizTakersReport } from "../types";
import { simpleFetcher } from "../fetcher";

/** Invited/completed report for one quiz (managers only). */
export function useQuizTakers(quizId: number | undefined) {
  return useSWR<QuizTakersReport, Error>(
    quizId ? `/api/v2/quizzes/${quizId}/takers` : null,
    simpleFetcher,
  );
}
